import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumbs from '../common/components/Breadcrumbs';
import DealerSearch from './search/DealerSearch';
import DealersTable from './DealersTable';
import DealersStatusFilter from './DealersStatusFilter';
import { setQueryString, useQueryString } from '../common/helpers/queryString';
import { searchDealer } from './DealersActions';
import { scrollToElement } from '../common/helpers/scrollToElement';

const breadcrumbsItems = [
  { id: 1, type: 'home' },
  { id: 2, type: 'span', text: 'Dealers' },
];

const DealersPage = ({ history, location }) => {
  const query = useQueryString();
  const dispatch = useDispatch();

  const previousSearchState = useSelector(state => state.dealers.get('searchState'));
  const items = useSelector(state => state.dealers.get('items'));
  const totalItems = useSelector(state => state.dealers.get('totalItems'));

  const [scrolledToElem, setScrolledToElem] = useState(false);
  const initialSearchParams = {
    offset: query.get('page') ? +query.get('page') - 1 : 0,
  };
  const [searchParams, setSearchParams] = useState(
    previousSearchState?.searchParams || initialSearchParams,
  );

  useEffect(() => {
    setTimeout(() => {
      if (!scrolledToElem && previousSearchState?.dealerId && items) {
        scrollToElement(`dealer-row-${previousSearchState.dealerId}`);
        setScrolledToElem(true);
      }
    }, 100);
  }, [previousSearchState, items, scrolledToElem]);

  useEffect(() => {
    dispatch(
      searchDealer({
        ...searchParams,
        tradeName:
          typeof searchParams?.tradeName === 'object'
            ? searchParams?.tradeName?.label
            : searchParams?.tradeName,
      }),
    );
  }, [dispatch, searchParams]);

  const handleChangeStatus = status => {
    setSearchParams(prevState => ({ ...prevState, status, offset: 0 }));
  };

  const handleSearch = (values, { setSubmitting }) => {
    setSearchParams(prevState => ({
      ...prevState,
      ...values,
      tradeName: values?.tradeName?.label,
      offset: 0,
    }));
    setSubmitting(false);
  };

  const changeOffset = value => {
    setSearchParams(prevState => ({ ...prevState, offset: value }));
    history.push(setQueryString(location, 'page', value + 1));
  };

  return (
    <div className="content">
      <Breadcrumbs items={breadcrumbsItems} />
      <DealerSearch handleSearch={handleSearch} />
      <DealersStatusFilter
        handleChangeStatus={handleChangeStatus}
        previousSelectedStatus={previousSearchState?.searchParams?.status}
      />
      <DealersTable
        data={{ items, total: totalItems }}
        offset={searchParams.offset}
        changeOffset={changeOffset}
        searchParams={searchParams}
      />
    </div>
  );
};

export default withRouter(DealersPage);
